import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  CheckDuplicateEntityDistanceShippingFeeCodeQuery,
  EntityDistanceShippingFeeQuery,
  EntityDistanceShippingFeesApi,
} from 'api';
import { entityDistanceShippingFeeQuery } from 'containers/Branding/Farm/Setting/commons/query';

export const createEntityDistanceShippingFee = createAsyncThunk(
  'entityDistanceShippingFee/createEntityDistanceShippingFee',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityDistanceShippingFeesApi.create(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const checkDuplicateEntityDistanceShippingFeeCode = createAsyncThunk(
  'entityDistanceShippingFee/checkDuplicateEntityDistanceShippingFeeCode',
  async (
    query: CheckDuplicateEntityDistanceShippingFeeCodeQuery,
    { rejectWithValue }
  ) => {
    try {
      const response = await EntityDistanceShippingFeesApi.checkDuplicate(
        query
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityDistanceShippingFee = createAsyncThunk(
  'entityDistanceShippingFee/findEntityDistanceShippingFee',
  async (option: EntityDistanceShippingFeeQuery, { rejectWithValue }) => {
    try {
      const response = await EntityDistanceShippingFeesApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface Update {
  id: string;
  body: any;
}
export const updateEntityDistanceShippingFee = createAsyncThunk(
  'entityDistanceShippingFee/updateEntityDistanceShippingFee',
  async (params: Update, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntityDistanceShippingFeesApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeEntityDistanceShippingFee = createAsyncThunk(
  'entityDistanceShippingFee/removeEntityDistanceShippingFee',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityDistanceShippingFeesApi.remove(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface State {
  tableList: Array<any>;
  orderList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  query: any;
}

const initialState: State = {
  tableList: [],
  orderList: [],
  list: [],
  reloadFlag: false,
  query: entityDistanceShippingFeeQuery,
};

const entityDistanceShippingFeeSlice = createSlice({
  name: 'entityDistanceShippingFee',
  initialState,
  reducers: {
    reloadEntityDistanceShippingFee(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
  extraReducers: builder => {
    builder.addCase(
      findEntityDistanceShippingFee.fulfilled,
      (state, action) => {
        const { data } = action.payload;

        state.tableList = data;
      }
    );
  },
});

const { actions, reducer: entityDistanceShippingFeeReducer } =
  entityDistanceShippingFeeSlice;

export const { reloadEntityDistanceShippingFee } = actions;

export default entityDistanceShippingFeeReducer;
